import { almeApi, almeNotificationApi } from '../../../util/alme-api';
import { ConverseRequestDetailsV5 } from '@alme/api-ts/Alme/ConverseRequestDetails';
import { RequestUnitRequestDetailsV5 } from '@alme/api-ts/Alme/RequestUnitRequestDetails';
import { AppEventRequestDetailsV5 } from '@alme/api-ts/Alme/AppEventRequestDetails';
import { ReportingEventRequestDetailsV5 } from '@alme/api-ts/Alme/ReportingEventRequestDetails';
import { HistoryRequestDetailsV5 } from '@alme/api-ts/Alme/HistoryRequestDetails';
import { ConfigurationRequestDetailsV5 } from '@alme/api-ts/Alme/ConfigurationRequestDetails';
import { NotificationRequestDetails } from '@alme/api-ts/Notification/NotificationRequestDetails';
import { AlmeUIInput } from '../../../types/input';
import { AlmeUIResponse } from '../../../types/response';



async function ConverseRequest(input: AlmeUIInput, accessKey: string): Promise<AlmeUIResponse>{
    return await almeApi.SendInputAsync(new ConverseRequestDetailsV5(
                input.userId || "",
                input.sessionId || "",
                input.text || "",
                input.origin || "Typed",
                input.displayText || input.text,
                input.parameters,
                input.channel,
                input.language,
                accessKey));
}

async function RequestUnitRequest(input: AlmeUIInput, accessKey: string): Promise<AlmeUIResponse>{
    return await almeApi.SendRequestUnitAsync(new RequestUnitRequestDetailsV5(
                input.userId || "",
                input.sessionId || "",
                input.unitId || "",
                input.displayText || "",
                input.origin || "Typed",
                input.parameters,
                input.language,
                input.channel,
                accessKey));
}

async function AppeventRequest(input: AlmeUIInput, accessKey: string): Promise<AlmeUIResponse>{
    return await almeApi.SendAppEventAsync(new AppEventRequestDetailsV5(
                input.userId || "",
                input.sessionId || "",
                input.eventName || "",
                input.origin,
                input.parameters,
                input.channel,
                input.language,
                accessKey));
}

async function ReportingEventRequest(input: AlmeUIInput, accessKey: string): Promise<boolean>{
    return await almeApi.SendReportingEventAsync(new ReportingEventRequestDetailsV5(
                input.userId || "",
                input.sessionId || "",
                input.eventName || "",
                input.eventValue || "",
                input.channel,
                accessKey
            ));
}

async function GetHistoryRequest(input: AlmeUIInput): Promise<AlmeUIResponse>{
    return await almeApi.GetHistoryAsync(new HistoryRequestDetailsV5(
                input.sessionId || "",
                input.messageLimit,
                input.includeRevertedEntries
            ));
}

async function GetConfigurationRequest(input: AlmeUIInput): Promise<AlmeUIResponse>{
    return await almeApi.GetConfigurationAsync(new ConfigurationRequestDetailsV5(
                input.channel
            ));
}

async function GetNotificationRequest(input: AlmeUIInput): Promise<AlmeUIResponse>{
    return await almeNotificationApi.GetNotificationAsync(new NotificationRequestDetails(
                input.sessionId || ""
            ));
}

export {
    ConverseRequest,
    RequestUnitRequest,
    AppeventRequest,
    ReportingEventRequest,
    GetHistoryRequest,
    GetConfigurationRequest,
    GetNotificationRequest,
};


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/lib-alme-request/src/request-mapper.ts